
export const FROM_9PM_TO_7AM = "FROM_9PM_TO_7AM";
export const FROM_7AM_TO_4PM = "FROM_7AM_TO_4PM";
export const FROM_4PM_TO_9PM = "FROM_4PM_TO_9PM";

export const FROM_12AM_TO_6AM = "FROM_12AM_TO_6AM";
export const FROM_6AM_TO_4PM = "FROM_6AM_TO_4PM";
export const FROM_9PM_TO_12AM = "FROM_9PM_TO_12AM";
export const ALL_HOURS = "ALL_HOURS";
export const WEEKEND = "WEEKEND";